import React, { useState } from 'react';
import { string, number, bool, shape } from 'prop-types';
import cn from 'classnames';

import { cdnApi } from '~config/api';
import SimpleSpinner from '~components/SimpleSpinner';
import { MARKER_STORE_COLOR, GOOGLE_MAPS_STATIC_URL, QUALITY } from '~constants/maps';

import { STORE_MARKER_PATH } from './constants';
import styles from './styles.module.scss';

function StaticMap({ size, scale, center, zoom, markers, storeMarkers, className, quality }) {
  const [loading, setLoading] = useState(true);

  const onLoadImage = () => {
    setLoading(false);
  };

  const icon = `${cdnApi.getBaseURL()}${STORE_MARKER_PATH}`;
  const params = {
    size,
    scale,
    center: `${center.lat},${center.lng}`,
    zoom: zoom ? zoom : '',
    format: quality ? quality : QUALITY.fast,
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  };
  const paramString = new URLSearchParams(params);

  if (markers) {
    markers.map((marker, index) =>
      paramString.append(
        'markers',
        `label:${index + 1}|color:${MARKER_STORE_COLOR}|${marker.latitude},${marker.longitude}`
      )
    );
  }

  storeMarkers
    ? paramString.append('markers', `icon:${icon}|${center.lat},${center.lng}`)
    : paramString.append('markers', `${center.lat},${center.lng}`);

  const staticMapUrl = `${GOOGLE_MAPS_STATIC_URL}${paramString.toString()}`;

  return (
    <>
      <img
        className={cn('force-center', className, { hide: loading })}
        onLoad={onLoadImage}
        src={staticMapUrl}
        alt={staticMapUrl}
      />
      <SimpleSpinner
        containerClassName={cn(styles.containerSpinner, { hide: !loading })}
        className={styles.spinner}
      />
    </>
  );
}

StaticMap.propTypes = {
  center: shape({
    lat: string,
    lng: string
  }),
  className: string,
  markers: shape({
    latitude: string,
    longitude: string
  }),
  quality: string,
  scale: string,
  size: string,
  storeMarkers: bool,
  zoom: number
};

export default StaticMap;
